import { ApiPaths } from "@app/helpers/api";
import { NgayNghi } from "@app/models/ngaynghi/NgayNghi";
import { responseStatus } from "../constants";
import intance from "../utils/axios";

export const timKiemDSNgayNghi = async (idLoaiNgayNghi: number, tuKhoa: string, start: number, length: number) => {
    var data = {
        data: [],
        recordsTotal: 0,
    };
    await intance.post(ApiPaths.ngayNghi.timKiemDSNgayNghi, {
        "start": start,
        "length": length,
        "filter": {
            "idLoaiNgayNghi": idLoaiNgayNghi,
            "tuKhoa": tuKhoa
        },
        "orderBy": {
            "columnName": "ten",
            "isDesc": true
        }
    })
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};


export const layChiTiet = async (id: number) => {
    var data = new NgayNghi;
    await intance.get(ApiPaths.ngayNghi.chiTiet + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const luuNgayNghi = async (data: any) => {
    await intance.post(ApiPaths.ngayNghi.luuNgayNghi, data)
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch(err => {
            throw err;
        });
}

export const xoaNgayNghi = async (id: number) => {
    await intance.get(ApiPaths.ngayNghi.xoaNgayNghi + "?id=" + id)
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch(err => {
            throw err;
        });
}